import {
  TextImportCandidatePageResponse,
  TextImportSourceListResponse,
} from '../dto/ResDtoRepository';
import { sendApiRequest } from './apiConfig';

export const getTextImportSources = async (
  aui: string,
): Promise<TextImportSourceListResponse> => {
  const params = new URLSearchParams({ aui });
  return sendApiRequest<TextImportSourceListResponse>(
    'get',
    `/api/v1/text/import/source/list/owner?${params.toString()}`,
  );
};

export const getTextImportCandidates = async (
  aui: string,
  groupMemberId: number,
  page: number,
): Promise<TextImportCandidatePageResponse> => {
  const params = new URLSearchParams({
    aui,
    groupMemberId: String(groupMemberId),
    page: String(page),
    size: '10',
  });
  return sendApiRequest<TextImportCandidatePageResponse>(
    'get',
    `/api/v1/text/import/candidate/list/owner?${params.toString()}`,
  );
};
